import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

const ArrowForward = (): JSX.Element => <ArrowForwardIcon fontSize="inherit" />;

export default ArrowForward;
